// extracted by mini-css-extract-plugin
export var closed = "_ii-1";
export var resizer = "_ii-0";